import { Component, EventEmitter, Output } from '@angular/core';
import { MainStateService } from 'src/app/services/state/app-main-state.service';
import { ButtonStateService } from 'src/app/services/state/button-state.service';

@Component({
    selector: 'yf-avvia-prenotazione',
    template: `
    <ion-button
      class="btn square"
      [ngClass]="{
        white: this.mainStateService.$selectedConnectorHasMineSession(),
        secondary: !this.mainStateService.$selectedConnectorHasMineSession(),
        disabled: this.buttonStateService.$buttonStartReservation().disabled
      }"
      [disabled]="this.buttonStateService.$buttonStartReservation().disabled"
      (click)="reserve()"
      debounceClick>
      <ion-icon slot="icon-only" src="assets/app-icons/cronometro.svg"></ion-icon>
  </ion-button>
  `,
    standalone: false
})
export class AvviaPrenotazioneComponent {
  @Output() reserveEvent: EventEmitter<void> = new EventEmitter<void>();
    
  constructor(
    public mainStateService: MainStateService,
    public buttonStateService: ButtonStateService
  ) {
    
  }

  reserve() {
    this.reserveEvent.emit();
  }
}
